import * as React from 'react';
import { Switch as NativeSwitch, Tooltip } from 'radix-ui';

interface SwitchProps extends React.ComponentProps<(typeof NativeSwitch)['Root']> {
  label?: React.ReactNode;
  tooltip?: React.ReactNode;
  testId?: string;
  tooltipProps?: React.ComponentProps<(typeof Tooltip)['Root']>;
}

const Switch = ({
  label,
  tooltip,
  checked,
  disabled,
  testId = 'switch',
  ...rest
}: SwitchProps) => {
  const switchElement = (
    <NativeSwitch.Root
      {...rest}
      checked={checked}
      disabled={disabled}
      className={`relative h-[24px] w-[44px] ${
        disabled ? 'cursor-not-allowed' : 'cursor-pointer'
      } rounded-full outline-none ${
        checked ? 'bg-primary-500' : 'bg-slate-300'
      } data-[state=checked]:bg-primary-500 disabled:opacity-50`}
      data-testid={`${testId}-root`}
    >
      <NativeSwitch.Thumb
        className="block size-[16px] translate-x-0.5 rounded-full bg-white transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-[26px] disabled:bg-slate-200"
        data-testid={`${testId}-thumb`}
      />
    </NativeSwitch.Root>
  );

  if (tooltip) {
    return (
      <Tooltip.Root>
        <div className="flex items-center z-50">
          {label}
          <Tooltip.Trigger data-testid={`${testId}-tooltip-trigger`} asChild>
            {switchElement}
          </Tooltip.Trigger>
          <Tooltip.Content
            data-testid={`${testId}-tooltip-content`}
            className="relative z-50 bg-gray-900 text-white text-xs px-2 py-1 rounded shadow-lg"
          >
            {tooltip}
            <Tooltip.Arrow className="fill-gray-900" />
          </Tooltip.Content>
        </div>
      </Tooltip.Root>
    );
  }

  return (
    <div className="flex items-center">
      {label}
      {switchElement}
    </div>
  );
};

export default Switch;
